// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--2KjWj","mainText":"footer-module--mainText--3AUhN","link":"footer-module--link--YSUyd","contact":"footer-module--contact--1kngN"};